<template>
    <section class="login-section left order-last order-md-first">
        <div class="container">
            <div class="row centered">
                <div class="col-12 col-lg-10">
                  <div class="row mb-0 mb-md-4 mb-lg-5 py-4 py-md-0">
                    <div class="col-12">
                      <h1 class="main-title">
                        <!--<img src="../assets/imgs/logo.png" style="width:50%;height: 50%">-->
                      </h1>
                    </div>
                  </div>
                  <div class="row mb-0 mb-md-4 mb-lg-5 py-4 py-md-0">
                      <div class="col-12">
                          <h1 class="main-title">
                              <span class="line">{{ __("top", this.translations.landingPage.pageTitle ) }}</span>
                          </h1>
                      </div>
                  </div>
                  <div class="row">

                  </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

    export default {
        name: "LandingPage",
        components: {
        }
    }
</script>

<style lang="scss" scoped>
    #login-page {
        overflow: auto;

        .login-section {
            display: flex;
            align-items: center;
            flex-direction: row;
            height: 100%;

            .centered {
                display: flex !important;
                justify-content: center !important;
            }

            .bottom-section {
                justify-content: center;
                position: absolute;
                width: 100%;
                bottom: 10px;
            }

            &.left {
                position: relative;

                .main-title {
                    font-family: $raleway;
                    color: $darkest-gray;
                    font-weight: 900;
                    line-height: 1.1;
                    text-transform: uppercase;
                    font-size: 40px;

                    .line {
                        display: flex;
                        align-items: center;
                    }
                }
            }

            &.right {
                position: relative;
                background-color: $primary;

                .login-form {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    width: 100%;

                    .form-title {
                        width: 100%;
                        margin: 0 0 10px 0;
                        font-size: 22px;
                        font-weight: 700;
                        font-family: $raleway;
                        color: $white;
                        line-height: 1;
                        text-align: left;
                    }

                    .form-description {
                        font-family: $roboto;
                        font-size: 14px;
                        line-height: 1.4;
                        color: $light-gray;
                        text-align: left;

                        a {
                            color: $light-gray !important;
                            text-decoration: underline;
                            cursor: pointer;

                            &:hover {
                                text-decoration: none;
                            }
                        }
                    }

                    .form-error {
                        width: 100%;
                        color: $white;
                        font-family: $lato;
                        font-weight: 400;
                        font-size: 15px;
                        color: $orange;

                        ul {
                            margin: 0;
                        }

                        i {
                            margin: 0px 7px 0px 0px;
                        }
                    }

                    .form-field {
                        width: 100%;
                    }

                    .form-button {
                        display: block;
                        width: 100%;
                        padding: 7px 0;
                        font-weight: 700;
                        font-family: $raleway;
                        border: 2px solid $white !important;
                        border-radius: 25px;
                        color: $primary;
                        background-color: $white;

                        i {
                            margin: 0 10px 0 0;
                        }

                        &:hover {
                            color: $white;
                            background-color: transparent;
                        }

                        &:disabled {
                            border: 2px solid $light-gray !important;
                            background-color: $light-gray;
                            color: $dark-gray;

                            &:hover {
                                background-color: $light-gray;
                            }
                        }
                    }
                }

                .languages {
                    display: flex;
                    align-items: center;

                    .language-btn {
                        margin: 0 5px 0 0;
                        padding: 1px 8px;
                        font-size: 12px;
                        font-weight: 700;
                        font-family: $raleway;
                        text-transform: uppercase;
                        color: $white;
                        background: none;
                        @include removeBootstrapOutline;
                        border: 2px solid transparent !important;
                        border-radius: 3px;
                        cursor: pointer;
                        @include fastestTransition;

                        &:hover, &.active {
                            border: 2px solid $white !important
                        }

                        &:last-child {
                            margin: 0;
                        }
                    }
                }
            }
        }
    }

    .dark {
        #login-page {
            .login-section {
                &.left {
                    .main-title {
                        color: $white;
                    }
                }

                &.right {
                    background-color: $extra-darker-gray;

                    .login-form {
                        .form-error {
                            color: $light-red;
                        }

                        .form-button {
                            color: $extra-darker-gray;

                            &:hover {
                                color: $white;
                            }

                            &:disabled {
                                color: $gray;
                                border: 2px solid $extra-dark-gray !important;
                                background-color: $extra-dark-gray;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: $breakpoint-md) {
        #login-page {
            flex-direction: column;

            .login-section {
                height: auto;
                flex-direction: column;

                .centered {
                    display: block;
                }

                .bottom-section {
                    position: static;
                    transform: translate(0);
                    padding: 10px 0;
                }

                &.left {
                    width: 100%;

                    .main-title {
                        font-size: 22px;

                        .line {
                            display: inline;
                        }
                    }
                }

                &.right {
                    width: 100%;

                    .login-form {
                        padding: 30px 20px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: $breakpoint-md) {
        #login-page {
            .login-section {
                .centered {
                    display: block;
                }

                &.left {
                    width: 50%;

                    .main-title {
                        font-size: 30px;
                    }
                }

                &.right {
                    width: 50%;

                    .login-form {
                        padding: 0 25px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: $breakpoint-lg) {
        #login-page {
            .login-section {
                &.left {
                    width: 70%;
                }

                &.right {
                    width: 30%;

                    .login-form {
                        padding: 0 35px;
                    }
                }
            }
        }
    }
</style>
